import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { BrandColors } from '../../constants/brandColors';

export const AccessibilityStyles = makeStyles((theme: Theme) =>
  createStyles({
    acessibilityList: {
      listStyle: 'none',
      margin: '16px 0 0 0',
      padding: 0,
      '& > li': {
        marginBottom: '16px',
        '&:last-child': {
          marginBottom: '0px',
        },
      },
      '& .accInput': {
        position: 'absolute !important',
        width: '1px !important',
        height: '1px !important',
        margin: '-1px !important',
        padding: '0px !important',
        overflow: 'hidden',
        clip: 'rect(0px, 0px, 0px, 0px)',
        border: '0px',
      },
      '& .accText': {
        wordWrap: 'break-word',
        display: 'block',
        maxWidth: '85%',
      },
      '& .accRadio': {
        display: 'block',
        width: '25px',
        minWidth: '25px',
        height: '25px',
        borderRadius: '300px',
        position: 'relative',
        backgroundColor: '#c9cdd1',
        boxShadow: 'inset 0px 2px 3px rgba(153, 153, 153, 0.5)',
      },
      '& .accRadio-selected': {
        display: 'block',
        width: '25px',
        minWidth: '25px',
        height: '25px',
        borderRadius: '300px',
        position: 'relative',
        backgroundColor: theme.palette.primary.main,
        border: '5px solid',
        borderColor: '#c9cdd1',
        boxShadow: 'inset 0px 2px 3px rgba(153, 153, 153, 0.5)',
      },
      '& .accRadio-selected::before': {
        content: '',
        display: 'block',
        width: '15px',
        height: '15px',
        borderRadius: '300px',
        position: 'absolute',
        left: '5px',
        top: '5px',
        backgroundColor: theme.palette.primary.main,
        boxShadow: '0px 0px 4px 2px rgba(0, 0, 0, 0.05)',
      },
    },
    accessibilityDefaultAnchorColor: {
      cursor: 'pointer',
      color: BrandColors.muiLink,
      textDecoration: 'none',
      '&:hover': {
        color: BrandColors.link,
      },
      '&:focus': {
        outline: `2px solid ${theme.palette.secondary.main} !important`,
      },
    },
    accessibilityLabel: {
      width: '100%',
      minWidth: '120px',
      height: '48px',
      borderRadius: '16px',
      boxShadow: '0px 0px 5px #999',
      paddingLeft: '16px',
      paddingRight: '16px',
      margin: 0,
      textAlign: 'left',
      userSelect: 'none',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',

      wordWrap: 'break-word',
    },
    screenContent: {
      position: 'fixed',
      overflow: 'auto',
      width: '100%',
      height: '100%',
      background: theme.palette.background.paper,
      padding: '0rem 3.125rem',
      top: '0rem',
      zIndex: 100,
      '& .accessibility-screen': {
        display: 'flex',
        flexDirection: 'row',
        maxWidth: '1000px',
        paddingTop: '16px',
      },
      '& .screen-box': {
        position: 'relative',
        width: '100%',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .continueBtn': {
        margin: '1rem',
        borderRadius: '2rem',
        textTransform: 'uppercase',
      },
      '& .screen-footer': {
        padding: '32px',
        paddingTop: '0px',
        position: 'relative',
        width: '100%',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center',
        minWidth: '12.5rem',
        maxWidth: '62.5rem',
        [theme.breakpoints.up('sm')]: {
          justifyContent: 'flex-end',
        },
      },
    },
  }),
);
